import React from 'react';
import { useReservations } from '../ReservationContext';

const SettingsView = () => {
  const {
    loading,
    settingsFormData,
    setSettingsFormData,
    saveSettings,
  } = useReservations();

  const handleSave = async () => {
    await saveSettings();
  };

  return (
    <div className="settings-view">
      <div className="settings-header">
        <h3>Reservation Settings</h3>
        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Save Settings'}
        </button>
      </div>

      <div className="settings-grid">
        <div className="settings-section">
          <h4>General Settings</h4>

          <div className="form-group">
            <label>Reservations Active</label>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={settingsFormData.is_active}
                onChange={(e) => setSettingsFormData({ ...settingsFormData, is_active: e.target.checked })}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="form-group">
            <label>Time Interval (minutes)</label>
            <select
              value={settingsFormData.interval_minutes}
              onChange={(e) => setSettingsFormData({ ...settingsFormData, interval_minutes: parseInt(e.target.value) })}
            >
              <option value={15}>15 minutes</option>
              <option value={30}>30 minutes</option>
            </select>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Opening Time</label>
              <input
                type="time"
                value={settingsFormData.operating_hours_start}
                onChange={(e) => setSettingsFormData({ ...settingsFormData, operating_hours_start: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Closing Time</label>
              <input
                type="time"
                value={settingsFormData.operating_hours_end}
                onChange={(e) => setSettingsFormData({ ...settingsFormData, operating_hours_end: e.target.value })}
              />
            </div>
          </div>
        </div>

        <div className="settings-section">
          <h4>Capacity Settings</h4>

          <div className="form-group">
            <label>Total Capacity (seats)</label>
            <input
              type="number"
              min="1"
              value={settingsFormData.total_capacity}
              onChange={(e) => setSettingsFormData({ ...settingsFormData, total_capacity: parseInt(e.target.value) })}
            />
          </div>

          <div className="form-group">
            <label>Default Turn Time (minutes)</label>
            <input
              type="number"
              min="30"
              max="240"
              step="15"
              value={settingsFormData.default_turn_time}
              onChange={(e) => setSettingsFormData({ ...settingsFormData, default_turn_time: parseInt(e.target.value) })}
            />
          </div>

          <div className="form-group">
            <label>Max Party Size</label>
            <input
              type="number"
              min="1"
              max="50"
              value={settingsFormData.max_party_size}
              onChange={(e) => setSettingsFormData({ ...settingsFormData, max_party_size: parseInt(e.target.value) })}
            />
          </div>

          <div className="form-group">
            <label>Walk-in Reserve (%)</label>
            <input
              type="number"
              min="0"
              max="50"
              value={settingsFormData.walk_in_reserve_percent}
              onChange={(e) => setSettingsFormData({ ...settingsFormData, walk_in_reserve_percent: parseInt(e.target.value) })}
            />
            <span className="form-hint">Percentage of capacity reserved for walk-ins</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsView;
